import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { Error } from '../../shared/models/error.model';
import { RequestService } from '../../shared/services/request.service';
import { OrderStatus } from '../orders/enums/order-status.enum';
import { PaymentStatus } from '../orders/enums/payment-status.enum';
import { StatisticsFilter } from './models/statistics.filter';
import { TotalOrdersReport, TotalOrdersReportResponse } from './models/total-orders-report';

@Injectable()
export class StatisticsService {

	constructor(private requestService: RequestService) { }

	getTotalOrdersReport(filter: StatisticsFilter, page: number, size: number): Promise<TotalOrdersReportResponse> {
		return new Promise((resolve, reject) => {
			console.log(filter);
			let urlRequest: string = this.requestService.buildUrlPathParams(
				{
					groupbyday: filter.grouped,
					startDate: filter.startDate,
					endDate: filter.endDate,
					estabId: filter.establishmentId,
					count: filter.count,
					page: page,
					size: size
				},
				APP_CONFIG.WEBSERVICE.GET_TOTAL_ORDERS_REPORT
			);
			urlRequest += "&paymentStatus=" + PaymentStatus.PAID + "," + PaymentStatus.CANCELLED + "," + PaymentStatus.REVERSED;

			const filterOrderStatus: Array<OrderStatus> = [
				// OrderStatus.IN_QUEUE['code'],
				// OrderStatus.IN_PRODUCTION['code'],
				// OrderStatus.PARTIAL_DELIVERED['code'],
				// OrderStatus.FINISHED['code'],
				OrderStatus.RATED['code'],
				OrderStatus.DELIVERED['code'],
				OrderStatus.CANCELED_BY_ESTABLISHMENT['code'],
				OrderStatus.CANCELED_BY_CUSTOMER['code']
			];

			urlRequest += "&orderStatus=" + filterOrderStatus.join(",");

			console.log(urlRequest);
			this.requestService.getData(urlRequest).then((response: TotalOrdersReportResponse) => {
				const totalOrders: Array<TotalOrdersReport> = new Array<TotalOrdersReport>();
				if (response && response.ordersReport) {
					response.ordersReport.forEach((total) => {
						totalOrders.push(new TotalOrdersReport(total));
					});
					response.ordersReport = totalOrders;
				}
				resolve(response);
			}, (error: Error) => {
				console.error(error);
				reject(error);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/statistics/statistics.service.ts